import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Button, ButtonGroup, Col, Form, Input, Row} from 'reactstrap';
import Select from 'react-select';
import DataWrapper from "../../principal/containers/DataWrapper";
import ParametrosGeraisStore from "../stores/ParametrosGeraisStore";
import {createSelectOptions} from "../../../utils/formatar";
import {inteiroPositivo} from "../../../utils/formatar"
import {LoadingPanel} from "../../comum/components/LoadingPanel";
import {Validacao} from "../../comum/components/Validacao";
import loading from "../../../assets/images/ajax-loader.gif";


@inject("store")
@DataWrapper
@observer
export class ParametrosGerais extends Component {
    constructor(props) {
        super(props);
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.loadingPanelStore = this.props.store.loadingPanelStore;
        this.validacaoStore    = this.props.store.validacaoStore;
        this.formStore         = this.props.store.formStore;

        this.controller = new ParametrosGeraisStore(this.loadingPanelStore, this.validacaoStore, this.formStore);
    }

    componentDidMount() {
        this.controller.carregarDados();
        this.tituloPaginaStore.setTitulo("Parâmetros gerais do sistema");
        this.diaPgmOptions = [];
        for (let i = 1; i < 29; i++) {
            this.diaPgmOptions.push({value: i, label: i});
        }
    }

    error() {
        return (
            <div>
                <br/>
                <div className="form-buttons">
                    <span style={{color: 'red'}}>Existem dados inválidos no formulário. Favor corrigi-los antes de prosseguir.</span>
                </div>
            </div>);
    }

    render() {

        return (
            <div>
                <div className="form-wrapper">
                    <LoadingPanel>
                        <div className="content-panel panel-sm">
                            <Form className="panel-form">
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <div className="form-buttons">
                                            <ButtonGroup size="sm">
                                                {
                                                    this.controller.modoEdicao && this.controller.salvando &&
                                                    <img src={loading} alt="loading" className="loading"/>
                                                }
                                                {
                                                    this.controller.modoEdicao && !this.controller.salvando &&
                                                    <Button onClick={() => this.controller.reverter()}>Reverter</Button>
                                                }
                                                {
                                                    this.controller.modoEdicao && !this.controller.salvando &&
                                                    <Button color="primary" onClick={() => this.controller.salvar()}>Salvar</Button>
                                                }
                                                {
                                                    !this.controller.modoEdicao &&
                                                    <Button color="primary" onClick={() => this.controller.editar()}>Editar</Button>
                                                }
                                            </ButtonGroup>
                                        </div>
                                        {this.formStore.submitted && !this.validacaoStore.isValidForm ? this.error() : ''}
                                    </Col>
                                </Row>
                                <h4>Contratos Recorrentes</h4>
                                <Row>
                                    <Col>Quantidade de contratos sucessivos</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.crQntContratoSucessivo}
                                                onChange={(event) => this.controller.setCrQntContratoSucessivo(event.target.value)}/></Col>
                                </Row>
                                <Row>
                                    <Col>Período de análise</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.crPeriodoAnalise}
                                                onChange={(event) => this.controller.setCrPeriodoAnalise(event.target.value)}/></Col>
                                </Row>
                                <Row>
                                    <Col>Alocação mínima no intervalo (%)</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.crPrctAlocacaoMinIntervalo}
                                                onChange={(event) => this.controller.setCrPrctAlocacaoMinIntervalo(event.target.value)}/></Col>
                                </Row>
                                <h4>Formatos diferentes de contratação</h4>
                                <Row>
                                    <Col>Período de análise</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.fdcPeriodoAnalise}
                                                onChange={(event) => this.controller.setFdcPeriodoAnalise(event.target.value)}/></Col>
                                </Row>
                                <h4>Quarentena</h4>
                                <Row>
                                    <Col>Para contratos recorrentes (dias)</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.qrtParaContratosRecorrentes}
                                                onChange={(event) => this.controller.setQrtParaContratosRecorrentes(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col>Para formatos diferentes de contratação (dias)</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.qrtParaFmtDiferenteContratacao}
                                                onChange={(event) => this.controller.setQrtParaFmtDiferenteContratacao(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col>Para ex-MOT (dias)</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.qrtParaExMot}
                                                onChange={(event) => this.controller.setQrtParaExMot(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col>Para ex-PSP (dias)</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.qrtParaExPsp}
                                                onChange={(event) => this.controller.setQrtParaExPsp(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col>Para ex-funcionário (dias)</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.qrtParaExFuncionario}
                                                onChange={(event) => this.controller.setQrtParaExFuncionario(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col>Para ex-terceiro (dias)</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.qrtParaExTerceiro}
                                                onChange={(event) => this.controller.setQrtParaExTerceiro(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col>Cargos não considerados</Col>
                                    <Col>
                                        <Select simpleValue disabled={!this.controller.modoEdicao}
                                                options={createSelectOptions(this.controller.cargos, "id", "nome")}
                                                value={this.controller.idCargosSelecionados}
                                                onChange={(value) => this.controller.setQrtCargosNaoConsideradosIds(value)}
                                                multi={true} placeholder="Selecione..."
                                                noResultsText="Nenhum resultado encontrado"/>
                                    </Col>

                                </Row>
                                <h4>SLAs (dias corridos)</h4>
                                <h5>ETT</h5>
                                <Row>
                                    <Col>Tempo para reivindicar solicitação</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.slaEttTmpReinv}
                                                onChange={(event) => this.controller.setSlaEttTempReinv(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col>Tempo para envio de solicitação após reivindicada</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.slaEttTmpEnvioAposReinv}
                                                onChange={(event) => this.controller.setSlaEttTmpEnvioAposReinv(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col>Tempo para responder prorrogação</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.slaEttTmpRespProrrogacao}
                                                onChange={(event) => this.controller.setSlaEttTmpRespProrrogacao(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col>Tempo para responder substituição</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.slaEttTmpRespSubstituicao}
                                                onChange={(event) => this.controller.setSlaEttTmpRespSubstituicao(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col>Tempo para responder término antecipado</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.slaEttTmpRespTA}
                                                onChange={(event) => this.controller.setSlaEttTmpRespTA(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col>Tempo para envio de lançamento de horas</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.slaEttTmpEnvioLH}
                                                onChange={(event) => this.controller.setSlaEttTmpEnvioLH(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col>Tempo para envio de dados de nota fiscal</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.slaEttTmpEnvioDadosNF}
                                                onChange={(event) => this.controller.setSlaEttTmpEnvioDadosNF(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <h5>Solicitante</h5>
                                <Row>
                                    <Col>Tempo para responder aos ajustes demandados</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.slaSlcTmpRespAjustDemand}
                                                onChange={(event) => this.controller.setSlaSlcTmpRespAjustDemand(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <h5>Gestor solicitante/aprovador extra</h5>
                                <Row>
                                    <Col>Tempo para avaliar e responder</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.slaGslTmpAvaliarResponder}
                                                onChange={(event) => this.controller.setSlaGslTmpAvaliarResponder(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <h5>NGFT</h5>
                                <Row>
                                    <Col>Tempo para avaliar e responder</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.slaNgfTmpAvaliarResponder}
                                                onChange={(event) => this.controller.setSlaNgfTmpAvaliarResponder(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <h5>Diretor</h5>
                                <Row>
                                    <Col>Tempo para avaliar e responder</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.slaDirTmpAvaliarResponder}
                                                onChange={(event) => this.controller.setSlaDirTmpAvaliarResponder(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <h5>Geral</h5>
                                <Row>
                                    <Col>Tempo para SLA em alerta (amarelo)</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.slaGrlTmpAvaliarResponder}
                                                onChange={(event) => this.controller.setSlaGrlTmpAvaliarResponder(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <h5>Outros</h5>
                                <Row>
                                    <Col>Tempo para avaliar e responder</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.slaOutrosTmpResponder}
                                                onChange={(event) => this.controller.setSlaTmpOutrosResponder(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <h4>Salário MOT em relação ao salário Globo</h4>
                                <Row>
                                    <Col>Percentual a ser praticado</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.smrsgPrctPraticado}
                                                onChange={(event) => this.controller.setSmrsgPrctPraticado(event.target.value)}/></Col>
                                </Row>
                                <Row>
                                    <Col>Percentual mínimo</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.smrsgPrctMin}
                                                onChange={(event) => this.controller.setSmrsgPrctMin(event.target.value)}/></Col>
                                </Row>
                                <Row>
                                    <Col>Percentual máximo</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.smrsgPrctRgl}
                                                onChange={(event) => this.controller.setSmrsgPrctRgl(event.target.value)}/></Col>
                                </Row>
                                <Row>
                                    <Col>Percentual mínimo (maior que) para o qual é necessária a avaliação do
                                        gestor</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.smrsgPrctMinAvalGestor}
                                                onChange={(event) => this.controller.setSmrsgPrctMinAvalGestor(event.target.value)}/></Col>
                                </Row>
                                <Row>
                                    <Col>Percentual mínimo (maior que) para o qual é necessária a avaliação da área de
                                        remuneração</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.smrsgPrctMinAvalAR}
                                                onChange={(event) => this.controller.setSmrsgPrctMinAvalAR(event.target.value)}/></Col>
                                </Row>
                                <h4>Prazos mínimo e regulamentado para início de fluxo</h4>
                                <Row>
                                    <Col xs={6} md={6} lg={6}>Solicitação</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.pmrifSolicitacaoMin}
                                                onChange={(event) => this.controller.setPmrifSolicitacaoMin(inteiroPositivo(event.target.value))}/></Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.pmrifSolicitacaoRgl}
                                                onChange={(event) => this.controller.setPmrifSolicitacaoRgl(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col xs={6} md={6} lg={6}>Prorrogação 10 a 160 dias</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.pmrifProrrogUmMin}
                                                onChange={(event) => this.controller.setPmrifProrrogUmMin(inteiroPositivo(event.target.value))}/></Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.pmrifProrrogUmRgl}
                                                onChange={(event) => this.controller.setPmrifProrrogUmRgl(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col xs={6} md={6} lg={6}>Prorrogação 161 a 180 dias</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.pmrifProrrogDoisMin}
                                                onChange={(event) => this.controller.setPmrifProrrogDoisMin(inteiroPositivo(event.target.value))}/></Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.pmrifProrrogDoisRgl}
                                                onChange={(event) => this.controller.setPmrifProrrogDoisRgl(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <Row>
                                    <Col xs={6} md={6} lg={6}>Prorrogação superior a 180 dias</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.pmrifProrrogTresMin}
                                                onChange={(event) => this.controller.setPmrifProrrogTresMin(inteiroPositivo(event.target.value))}/></Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.pmrifProrrogTresRgl}
                                                onChange={(event) => this.controller.setPmrifProrrogTresRgl(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <h4>Prazos mínimo e regulamentado para alerta para início de fluxo</h4>
                                <Row>
                                    <Col xs={6} md={6} lg={6}>Prorrogação</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.pmraifProrrogUmMin}
                                                onChange={(event) => this.controller.setPmraifProrrogUmMin(inteiroPositivo(event.target.value))}/></Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="number"
                                                value={this.controller.parametros.pmraifProrrogUmRgl}
                                                onChange={(event) => this.controller.setPmraifProrrogUmRgl(inteiroPositivo(event.target.value))}/></Col>
                                </Row>
                                <h4>Pagamento</h4>
                                <Row>
                                    <Col xs={6} md={6} lg={6}>Dia inicial para período de apuração</Col>
                                    <Col>
                                        <Select simpleValue disabled={!this.controller.modoEdicao}
                                                options={this.diaPgmOptions}
                                                value={this.controller.parametros.pgmDiaIncPeriodoApuracao}
                                                onChange={(value) => this.controller.setPgmDiaIncPeriodoApuracao(value)}
                                                multi={false} placeholder="Selecione..."
                                                noResultsText="Nenhum resultado encontrado"/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6} md={6} lg={6}>Dia para geração de controle de ponto</Col>
                                    <Col>
                                        <Select simpleValue disabled={!this.controller.modoEdicao}
                                                options={this.diaPgmOptions}
                                                value={this.controller.parametros.pgmDiaGerControlePonto}
                                                onChange={(value) => this.controller.setPgmDiaGerControlePonto(value)}
                                                multi={false} placeholder="Selecione..."
                                                noResultsText="Nenhum resultado encontrado"/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6} md={6} lg={6}>Dia para geração de lotes de pagamento</Col>
                                    <Col>
                                        <Select simpleValue disabled={!this.controller.modoEdicao}
                                                options={this.diaPgmOptions}
                                                value={this.controller.parametros.pgmDiaGerLotePagamento}
                                                onChange={(value) => this.controller.setPgmDiaGerLotePagamento(value)}
                                                multi={false} placeholder="Selecione..."
                                                noResultsText="Nenhum resultado encontrado"/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6} md={6} lg={6}>Conta usada no lançamento da RC</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="text"
                                                value={this.controller.parametros.conta_rc}
                                                onChange={(event) => this.controller.setConta_rc(event.target.value)}/></Col>
                                </Row>
                                <Row>
                                    <Col xs={6} md={6} lg={6}>Item do acordo para RC</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="text"
                                                value={this.controller.parametros.itemContratoRc}
                                                onChange={(event) => this.controller.setItemContratoRc(event.target.value)}/></Col>
                                </Row>
                                <Row>
                                    <Col xs={6} md={6} lg={6}>E-mail responsável criação RC</Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="text"
                                                value={this.controller.parametros.emailCriacaoLP}
                                                onChange={(event) => this.controller.setEmailCriacaoLP(event.target.value)}/></Col>
                                </Row>
                                <h4>E-mail para solicitação de crachá</h4>
                                <Row>
                                    <Col xs={6} md={6} lg={6}>E-mail do destinatário <p> (Informe e-mails separados por vírgula) </p> </Col>
                                    <Col><Input disabled={!this.controller.modoEdicao} type="text" maxLength={1024}
                                                value={this.controller.parametros.emailSolicitacaoCracha}
                                                onChange={(event) => this.controller.setEmailSolicitacaoCracha(event.target.value)}/>
                                        <Validacao id={"emailSolicitacaoCracha"} valor={this.controller.parametros.emailSolicitacaoCracha} tipo={["isRequired", "areEmails"]} />
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </LoadingPanel>
                </div>
            </div>
        )
    }
}